"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.browseBooleanFacets = void 0;
exports.browseBooleanFacets = {
    is_outdoor_safe: 'outdoor',
};
